<template>
    <!-- 需載入vue, vuedraggable, MapConfig(地圖設定檔), WMarkerConfig(風標設定檔)  -->
    <div ref="kxd-map-container" class="kxd-map-container" :style="css_props">
        <section class="map-ctrl map-left-top-ctrl">

        </section>

        <section class="map-ctrl map-left-bottom-ctrl">
            <!--
                KXD產品colorbar <kxd-colorbar>
                位置: 地圖左下方
                說明: 控制KXD產品色階顯示 
            -->
            <colorbar
                v-for="options in colorbars"
                v-show="check_in_maptool_colorbars_list(options.name)"
                :key="options.name"
                :ref="'colorbar-' + options.name"
                :options="options"
                :class="'colorbar-container'"
                :draggable="true"
            />

            <div 
                v-if="Object.keys(max_rain).length > 0 && check_in_maptool_colorbars_list(max_rain.id)"
                v-draggable
                class="max-rain-colorbar__container"
            >
                <img :src="max_rain.src" width="100%">
            </div>
            
            <!-- 
                經緯度顯示元件 & 比例尺元件 <cursor-latlng>
                位置: 地圖左下方
                說明: 顯示滑鼠移至位置的經緯度 & 當前範圍地圖比例尺
            -->
            <cursor-latlng
                id="cursor_latlng_container"
                :lat="cursor_latlng.lat"
                :lng="cursor_latlng.lng"
                :map="map"
                :style="according_popup_table"
            ></cursor-latlng>
        </section>

        <section class="map-ctrl map-right-top-ctrl">
            <pane-tag
                v-for="(options, key) in panes_tag"
                :key="key"
                :options="options"
                :class="'map-top-item'"
            ></pane-tag>
            <pane-tag-case
                :class="'map-top-item'"
            />
        </section>

        <section class="map-ctrl map-right-bottom-ctrl">
            <div class="capture-img__container">
                <img 
                    src="/static/images/capture/white_cwa_logo_string_eng.png"
                    class="capture-img"
                    width="100%"
                />
                <div class="capture-img__description">
                    <template v-if="accumulated_precp.start_time && accumulated_precp.end_time">
                        <div>累積雨量查詢時間:</div>
                        <div>{{ accumulated_precp.start_time }} ~ {{ accumulated_precp.end_time }}</div>
                    </template>
                    <span v-else>{{ capture_datetime_description }}</span>
                </div>
            </div>
        </section>

        <section class="map-ctrl map-top-right-ctrl">
            <!--
                地圖工具 <map-btn-tool>
                位置: 地圖左上方
                說明: 控制地圖及產品的按鈕 
            -->

            <favorites-btn 
                ref="favorites_btn"
                v-if="client_name !== 'pub' && is_show_favorites" 
                @change_favorites_hint_text="change_favorites_hint_text"
            />

            <product-setting-btn
                ref="product_setting_btn"
                :is_show_favorites="is_show_favorites"
                @open-product-setting-dialog="open_product_setting_dialog"
            />

            <map-btn-tool
                id="map_btn_tool_container"
                :config="config.map"
                :map_zoom="zoom"
                :opacity_tool="panes_opacity"
                :order_tool="panes_order"
                @zoom_in="zoom_in"
                @zoom_out="zoom_out"
                @fit_bounds="fit_bounds"
                @set_map_view="set_map_view"
                @change_basemap="change_basemap"
                @toggle_boundary="toggle_boundary"
                @toggle_measure_tool="toggle_measure_tool"
                @capture="capture"
            ></map-btn-tool>

            <!-- measure-tool 元件, 僅控制器, 地圖物件實體位於pane裡 -->
            <measure-tool
                v-show="measure_tool.status"
                id="measure_tool_container"
                :class="'map-item-style map-shadow map-top-item'"
                :cursor_latlng="cursor_latlng"
                :tool="measure_tool"
                @create_layer="create_layer"
                @clear_pane="clear_pane"
            ></measure-tool>

            <div 
                v-show="product_setting_tool.status"
                class="map-root-item"
            >
                <product-setting-items
                    :panes="panes"
                    :panes_tag="panes_tag"
                    :opacity_tool="panes_opacity"
                    :order_tool="panes_order"
                    :all_map_config="config"
                    :props_zoom_level="zoom"
                    @change_visibility="change_visibility"
                    @change_order="change_order"
                    @change_opacity="change_opacity_by_user"
                    @change-zoom="change_zoom"
                    @close-product-setting-dialog="close_product_setting_dialog"
                />
            </div>
        </section>

        <!-- map 實體 -->
        <div ref="kxd-map" class="kxd-map" :zoom="zoom"></div>

        <!-- kxd-render 虛擬元件, 實體位於pane裡 -->
        <kxd-render
            v-for="(options, key) in kxd_renders"
            :key="options.key"
            :name="key"
            :text="panes_config[key].text"
            :options="options"
            :pane="panes[key]"
            :cursor_latlng="cursor_latlng"
            :colorbar="$refs['colorbar-' + key]"
            @create_colorbar="create_colorbar"
        ></kxd-render>

        <!-- kxd-render V2 虛擬元件, 實體位於pane裡 -->
        <kxd-render-v2
            v-for="(options, key) in kxd_renders_v2"
            :key="options.key"
            :name="key"
            :text="panes_config[key].text"
            :options="options"
            :pane="panes[key]"
            :cursor_latlng="cursor_latlng"
            :colorbar="$refs['colorbar-' + key]"
            @create_colorbar="create_colorbar"
        ></kxd-render-v2>

        <!-- wmarker 虛擬元件, 實體位於pane裡 -->
        <w-marker
            v-for="(options, key) in wmarkers"
            :key="options.key"
            :name="key"
            :options="options"
            :pane="panes[key]"
            :zoom="zoom"
        ></w-marker>

        <!-- nine-block 虛擬元件, 實體位於pane裡 -->
        <nine-block
            v-for="(options, pane_name) in nineblock_items"
            :key="`${nineblock_items_key}_${pane_name}`"
            :name="pane_name"
            :options="options"
            :pane="panes[pane_name]"
        ></nine-block>

        <!-- measure-item 虛擬元件, 實體位於pane裡 -->
        <measure-item
            v-for="(item, key) in measure_items"
            :key="key"
            :options="item"
            :measure_tool="measure_tool"
        ></measure-item>
    </div>
</template>

<script>
// KXDviz
import './KXDviz/X.Capture-0.0.2.js'
import './map-style.css'

// CanvasLayer
import './CanvasLayer/L.CanvasLayer.js'

import { get_remote_file_ajax } from '@/utils/emap/emap_init.js'
import { qplus_before_capture, qplus_after_capture } from '@/utils/emap/emap_tool.js'

import Vue from 'vue'
import 'jquery-ui-dist/jquery-ui'
import * as turf from '@turf/turf'
import { mapMutations, mapState } from 'vuex'
import 'leaflet.markercluster/dist/leaflet.markercluster'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'

import ProjWizard from './KXDviz/KXDviz-projWizard.js' // 圖片產品4326格式轉換工具
import CursorLatlng from './component/cursor-latlng.vue' // 滑鼠經緯度元件
import MapBtnTool from './component/map-btn-tool.vue' // 地圖工具元件
import MeasureTool from './component/measure-tool.vue' // 地圖工具元件
import KXDRender from './component/kxd-render.vue' // kxd 繪圖
import KXDRenderV2 from './component/kxd-render-v2.vue' // kxd 繪圖
import Colorbar from './component/colorbar.vue' // colorbar
import Wmarker from './component/wmarker.vue' // 風標
import NineBlock from './component/nineblock.vue' // 九宮格
import MeasureItem from './component/measure-item.vue' //編輯多角形元件

import PaneTag from '@/components/emap/render_custom_plugin/pane-tag.vue' // 產品標籤
import ProductSettingBtn from '@/components/emap/render_custom_plugin/product_setting_btn.vue'
import FavoritesBtn from '@/components/favorites/favorites.vue' // 我的最愛按鈕
import ProductSettingItems from '@/components/emap/render_custom_plugin/product_setting_items.vue'

window.DEV = window.DEV === true ? true : false

export default {
    name: 'kxd-map',
    props: [
        'kmap',
        'maptool_colorbars_list',
        'maptool_legends_list',
        'max_rain',
        'is_show_popup_table',
        'is_show_favorites',
    ],
    data: function() {
        return {
            map: null, //主地圖
            cursor_latlng: { lat: 0, lng: 0 },
            basemap: null, //目前顯示的底圖
            basemap_layer: {}, //根據config.map所產生的底圖
            boundary: null,
            panes: {}, //pane實體
            panes_config: {}, //pane的各項設定數值
            pane_order_type_list: ['top', 'boundary', 'normal'],
            pane_order_type: {
                top: [], //上層
                boundary: [], //界線(order_tool無效)
                normal: [], //下層(預設)
            },
            panes_order_list: [], //pane排序清單
            kxd_renders: {}, //render虛擬元件
            kxd_renders_v2: {}, //render V2虛擬元件
            colorbars: {}, //colorbar虛擬元件
            wmarkers: {}, //風標虛擬元件
            nineblock_items: {}, //九宮格虛擬元件
            measure_items: {}, //可編輯測量虛擬元件
            measure_tool: {
                //測量工具元件
                status: false,
                options: this.kmap.map_config.measure_tool || {},
                init: () => {},
                start: () => {},
                stop: () => {},
                get: () => {},
                reset: () => {},
            },
            product_setting_tool: {
                status: false,
            },
            capture_tool: {
                containerID: 'kxd_map_ID',
                filename: 'capture',
                hide_list: [],
                hide_Lctrl: true,
                before_capture: qplus_before_capture,
                after_capture: qplus_after_capture,
            },

            capture_datetime_description: '',
            capture_file_name: '',
            nineblock_items_key: 0,
        }
    },
    components: {
        'cursor-latlng': CursorLatlng,
        'map-btn-tool': MapBtnTool,
        'measure-tool': MeasureTool,
        'kxd-render': KXDRender,
        'kxd-render-v2': KXDRenderV2,
        colorbar: Colorbar, //colorbar元件
        'w-marker': Wmarker, //kxd render w-marker元件
        'nine-block': NineBlock, //kxd render 九宮格元件
        'measure-item': MeasureItem,

        'pane-tag': PaneTag,
        'pane-tag-case': () => import('@/components/emap/render_custom_plugin/pane_tag_case.vue'),
        'product-setting-btn': ProductSettingBtn,
        'favorites-btn': FavoritesBtn,
        'product-setting-items': ProductSettingItems,
    },
    created() {
        // 新版需設定workerFolder資料夾位置, 3D可共用此設定
        // 正式機需要另外放入KXDParseDense.js這隻檔案
        if (KXD2r) KXD2r.setting.workerFolder = '/static/js/'
    },
    beforeMount: function() {},
    mounted: function() {
        this.initial_map()
    },
    computed: {
        ...mapState(['client_name']),
        ...mapState('emap', ['current_timestamp', 'accumulated_precp']),
        according_popup_table() {
            return { left: this.is_show_popup_table ? '365px' : '5px' }
        },
        config() {
            return {
                map: this.kmap.map_config || MapConfig,
                wmarker: this.kmap.wmarker_config || WMarkerConfig,
            }
        },
        boundary_config() {
            return this.config.map.basemap_boundary[0]
        },
        basemap_config() {
            return this.config.map.basemap_boundary[1]
        },
        basemap_config_list_for_reload_language() {
            const map_list = this.basemap_config.item.list.map(({ name }) => name)
            return map_list
        },
        measure_tool_config() {
            return this.config.map.measure_tool
        },
        css_props: function() {
            return {
                '--map-bg-color': this.kmap.map_bg_color || '#333',
            }
        },
        zoom: function() {
            return this.map ? this.map._zoom : null
        },
        panes_opacity: function() {
            // 圖層透明度工具 panes_opacity
            let obj = {
                data: [],
                set_val: {},
            }

            Object.keys(this.panes_config).forEach((pane_name) => {
                const options = this.panes_config[pane_name]
                if (options.opacity_tool) {
                    obj.data.push({ name: pane_name, text: options.text })
                    obj.set_val[pane_name] = options.opacity
                }
            })

            return obj
        },
        panes_order: function() {
            // 圖層順序工具 panes_order
            return this.pane_order_type_list
                .map((type) => {
                    if (type === 'boundary') {
                        const boundary_text = this.config.map.pane_text.basemap_boundary || '地理界線 Boundary'
                        return { name: 'boundary', text: boundary_text }
                    } else {
                        return this.pane_order_type[type]
                            .map((pane_name) => {
                                const options = this.panes_config[pane_name]
                                if (options.order_tool) {
                                    return { name: pane_name, text: options.text }
                                }
                            })
                            .filter((pane) => pane)
                    }
                })
                .flat()
        },
        panes_tag: function() {
            return Object.keys(this.panes_config)
                .map((pane_name) => {
                    const options = this.panes_config[pane_name]
                    if (options.pane_type !== 'boundary' && options.pane_tag_tool) {
                        return {
                            is_on_map: options.is_on_map,
                            is_loading: options.is_loading,
                            has_layer: Object.keys(options.layers).length ? true : false,
                            name: options.name,
                            text: options.text,

                            // qplus 新增
                            data: options.data,
                            tag_config: options.pane_tag_config,
                            type: options.type,
                            sub_type: options.sub_type,
                            information: options.information || [],
                        }
                    }
                })
                .filter((o) => o)
        },
    },
    methods: {
        ...mapMutations('favorites', ['set_zoom', 'set_center', 'set_basemap']),

        invalidate_size: function() {
            setTimeout(() => {
                this.map.invalidateSize(true)
            }, 1)
        },
        initial_map: function() {
            this.map = new L.Map(this.$refs['kxd-map'], {
                ...this.config.map.options,
                zoomAnimation: false,
                fadeAnimation: false,
                markerZoomAnimation: false,
            })
            this.map.on('mousemove', (e) => {
                this.cursor_latlng = e.latlng
            })

            // 用vuex儲存地圖中心 (for 我的最愛功能)
            this.map.on('dragend', (e) => {
                let x = this.map.getCenter().lat
                let y = this.map.getCenter().lng
                this.set_center([x, y])
            })

            // 設定截圖容器為地圖之父容器
            if (this.config.map.button && this.config.map.button.capture) {
                this.capture_tool.containerID = this.$refs['kxd-map-container'].parentElement.id
            }

            this.initial_basemap()
            this.initial_boundary()

            this.kmap.invalidate_size = this.invalidate_size //若初始地圖容器為無效大小, 需呼叫
            this.kmap.set_map_view = this.set_map_view //設定地圖中心位置及zoom值
            this.kmap.create_layer = this.create_layer //建立地圖層
            this.kmap.add_pane = this.add_pane //在地圖上顯示圖層
            this.kmap.remove_pane = this.remove_pane //在地圖上移除圖層
            this.kmap.clear_pane = this.clear_pane //清除圖層, 會保留設定及pane
            this.kmap.delete_pane = this.delete_pane //刪除圖層
            this.kmap.add_marker_tag = this.add_marker_tag //可拖曳且帶指引線的marker標籤
            this.kmap.draw_arrow = this.draw_arrow //畫箭頭工具
            this.kmap.get_theta_by_dir = this.get_theta_by_dir //風向角 轉為 極座標(radian)
            this.kmap.create_measure_item = this.create_measure_item //繪製可編輯多角形
            this.kmap.get_measure_item = this.get_measure_item //取得可編輯多角形經緯度
            this.kmap.get_intersect_area = this.get_intersect_area //取得兩區域之重疊區域
            this.kmap.measure_tool = this.measure_tool //取得繪製工具
            this.kmap.panes = this.panes
        },
        initial_basemap: function() {
            this.config.map.basemap.list.forEach((o) => {
                const name = o.name
                if (name === 'osm_zh') {
                    this.basemap_layer[name] = L.tileLayer('https://{s}.tile.osm.org/{z}/{x}/{y}.png', {
                        mode: 'light',
                        attribution:
                            '&copy; <a href="https://osm.org/copyright" tabindex="-1">OpenStreetMap</a> contributors',
                    })
                } else if (name === 'osm_en') {
                    this.basemap_layer[name] = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                        mode: 'light',
                        attribution:
                            '&copy; <a href="https://openstreetmap.org">OpenStreetMap</a> Contributors & <a href="https://www.mapbox.com/about/maps/">Mapbox</a>',
                    })
                } else if (name === 'nls_color') {
                    this.basemap_layer[name] = L.tileLayer(
                        'https://wmts.nlsc.gov.tw/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=EMAP&STYLE=_null&TILEMATRIXSET=EPSG:3857&TILEMATRIX=EPSG:3857:{z}&TILEROW={y}&TILECOL={x}&FORMAT=image%2Fpng',
                        {
                            mode: 'light',
                            attribution:
                                '&copy; <a target="_target" href="https://maps.nlsc.gov.tw/" tabindex="-1">國土測繪圖資網路地圖服務</a>',
                        }
                    )
                } else if (name === 'nls_color_en') {
                    this.basemap_layer[name] = L.tileLayer(
                        'https://wmts.nlsc.gov.tw/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=EMAP8&STYLE=_null&TILEMATRIXSET=EPSG:3857&TILEMATRIX=EPSG:3857:{z}&TILEROW={y}&TILECOL={x}&FORMAT=image%2Fpng',
                        {
                            mode: 'light',
                            attribution:
                                '&copy; <a target="_target" href="https://maps.nlsc.gov.tw/">Taiwan MAP Service</a>',
                        }
                    )
                } else if (name === 'nls_black') {
                    this.basemap_layer[name] = L.tileLayer(
                        'https://wmts.nlsc.gov.tw/wmts/EMAP2/default/EPSG:3857/{z}/{y}/{x}',
                        {
                            mode: 'dark',
                            attribution:
                                '&copy; <a target="_target" href="https://maps.nlsc.gov.tw/" tabindex="-1">國土測繪圖資網路地圖服務</a>',
                        }
                    )
                } else if (name === 'nls_black_en') {
                    this.basemap_layer[name] = L.tileLayer(
                        'https://wmts.nlsc.gov.tw/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=EMAP7&STYLE=_null&TILEMATRIXSET=EPSG:3857&TILEMATRIX=EPSG:3857:{z}&TILEROW={y}&TILECOL={x}&FORMAT=image%2Fpng',
                        {
                            mode: 'dark',
                            attribution:
                                '&copy; <a target="_target" href="https://maps.nlsc.gov.tw/">Taiwan MAP Service</a>',
                        }
                    )
                } else if (name === 'black') {
                    this.basemap_layer[name] = new L.LayerGroup([], {
                        mode: 'dark',
                    })
                } else if (name === 'mapy_cz') {
                    this.basemap_layer[name] = L.tileLayer('//mapserver.mapy.cz/base-m/{z}-{x}-{y}', {
                        attribution: '© Seznam.cz, a.s., © OpenStreetMap',
                    })
                }
            })

            const MAP_LANGUAGE_MAPPING = {
                osm_zh: 'osm_en',
                osm_en: 'osm_zh',
                nls_black: 'nls_black_en',
                nls_black_en: 'nls_black',
                nls_color: 'nls_color_en',
                nls_color_en: 'nls_color',
            }

            if (!this.basemap) {
                return (this.basemap = this.basemap_config.default)
            }

            if (!this.basemap_config.item.list.find(({ name }) => name === this.basemap)) {
                const basemap_changed_language = MAP_LANGUAGE_MAPPING[this.basemap]

                if (basemap_changed_language) {
                    this.config.map.basemap_boundary[1].default = basemap_changed_language
                    this.basemap = basemap_changed_language
                } else {
                    this.basemap = this.basemap_config.default
                }
            }
        },
        initial_boundary: function() {
            const config = this.boundary_config || {}
            const extra_list = config.item.extra_list || []
            const boundary_list = config.item.list.slice().concat(extra_list.slice())
            this.boundary = [...config.default]

            boundary_list.forEach((options) => {
                const name = options.name
                const setting = config.setting[name]
                const pane = setting.pane ? setting.pane : name

                let _options = {
                    is_on_map: this.boundary.includes(name),
                    pane: pane,
                    name: name,
                    text: options.text,
                    type: 'geojson',
                    url: setting.url,
                    pane_type: 'boundary',
                    style: setting.style,
                    opacity_tool: false,
                    render_hint: {
                        canvas_pane: true,
                        last_zoom: this.config.map.options.zoom,
                        last_mode: this.basemap_layer[this.basemap].options.mode,
                    },
                    update: (e, layer, pane) => {
                        let layer_options = {}

                        // update path weight
                        const last_zoom = pane.options.render_hint.last_zoom
                        const map_zoom = e.target._zoom
                        if (last_zoom !== map_zoom) {
                            const default_zoom = this.config.map.options.zoom
                            const default_weight = setting.style.weight || 3
                            const weight = (map_zoom * default_weight) / default_zoom
                            layer_options['weight'] = weight

                            pane.options.render_hint.last_zoom = map_zoom
                        }

                        // update boundary color
                        const last_mode = pane.options.render_hint.last_mode
                        const map_mode = this.basemap_layer[this.basemap].options.mode
                        if (last_mode !== map_mode && setting.color_bind_map) {
                            const mode_color = setting.color_bind_map[map_mode]
                            layer_options['color'] = mode_color

                            pane.options.render_hint.last_mode = map_mode
                        }

                        if (Object.keys(layer_options).length) {
                            layer.setStyle(layer_options)
                        }
                    },
                    callback: (options, pane) => {
                        $(pane.$el)
                            .find('canvas')
                            .css('pointer-events', 'none')
                    },
                }
                this.create_layer(_options)
            })
        },
        zoom_in: function() {
            this.map.zoomIn()
        },
        zoom_out: function() {
            this.map.zoomOut()
        },
        fit_bounds: function(bounds) {
            this.map.fitBounds(bounds)
        },
        change_basemap: function(basemap) {
            this.basemap = basemap
            this.set_basemap(basemap) // for 我的最愛功能，運用vuex存放背景地圖
        },
        toggle_boundary: function(name, status) {
            if (status) {
                this.panes[name].addTo(this.map)
                this.boundary = [...this.boundary, name]
            } else {
                this.panes[name].removeFrom(this.map)
                this.boundary = this.boundary.filter((item) => item !== name)
            }
        },
        change_opacity_by_user(name, opacity) {
            this.panes_config[name] = {
                ...this.panes_config[name],
                ...{
                    is_user_set_opacity: true,
                    opacity,
                },
            }
            this.change_opacity(name, opacity)
        },
        change_opacity: function(name, opacity) {
            let pane = this.panes[name]
            pane.$el.style.opacity = opacity
        },
        change_order: function(list) {
            const boundary_idx = list.indexOf('boundary')
            const boundary_pane_list = this.pane_order_type['boundary']
            const front = list.slice(0, boundary_idx)
            const back = list.slice(boundary_idx + 1)

            this.panes_order_list = front.concat(boundary_pane_list, back)
        },
        change_visibility(name, status) {
            const pane = this.panes[name]
            pane.$el.style.visibility = status
        },
        change_zoom(zoom_level) {
            this.map.setZoom(zoom_level)
        },
        set_capture: function(options) {
            Object.keys(options).forEach((key) => {
                this.capture_tool[key] = options[key]
            })
        },
        capture: function() {
            const xCap = new X.Capture()

            if (this.capture_tool.before_capture) {
                const timestamp_ISO = this.get_timestamp_ISO()
                this.capture_datetime_description = `${this.$t(
                    '__caputre.datetime_description'
                )}: ${timestamp_ISO.substring(0, 4)}/${timestamp_ISO.substring(5, 7)}/${timestamp_ISO.substring(
                    8,
                    10
                )} ${timestamp_ISO.substring(11, 13)}:${timestamp_ISO.substring(14, 16)}`
                this.capture_file_name = `map_${timestamp_ISO.substring(0, 4)}_${timestamp_ISO.substring(
                    5,
                    7
                )}_${timestamp_ISO.substring(8, 10)}_${timestamp_ISO.substring(11, 13)}_${timestamp_ISO.substring(
                    14,
                    16
                )}`
                this.capture_tool.before_capture.call(this)
            }

            // hide list item will not be capture
            let hide_list = []
            this.capture_tool.hide_list.forEach((o) => {
                if ($(o + ':visible').length) {
                    $(o).hide()
                    hide_list.push(o)
                }
            })

            xCap.capture(this.capture_tool.containerID, this.capture_tool.hide_Lctrl, () => {
                xCap.save(this.capture_file_name, 'image/png')

                // recovery hide list item
                hide_list.forEach((o) => {
                    $(o).show()
                })

                if (this.capture_tool.after_capture) {
                    this.capture_tool.after_capture.call(this)
                }
            })
        },
        toggle_measure_tool: function() {
            this.measure_tool.status = !this.measure_tool.status

            if (this.measure_tool.status) {
                this.measure_tool.start()
            } else {
                this.measure_tool.stop()
            }
        },
        create_layer: function(options) {
            //_options是要餵給leaflet的
            let _options = {
                name: options.name, //圖層key, 保留字:boundary
                type: options.type || null, //圖層種類, 依產品可區分為 geojson|gis|image|render|empty
                text: options.text || options.name, //顯示於地圖工具的文字
                url: options.url || null, //檔案路徑
                pane_type: options.pane_type || 'normal', //圖層排序階級, top/boundary/normal
                pane_opacity: options.pane_opacity || 1, //圖層透明度
                is_on_map: options.is_on_map === false ? false : true, //是否直接顯示在地圖上
                opacity_tool: options.opacity_tool === false ? false : true, //是否提供透明度工具
                order_tool: options.order_tool === false ? false : true, //是否提供圖層順序編輯工具
                pane_tag_tool: options.pane_tag_tool === false ? false : true, //是否顯示右上圖層標籤
                loaded_data: options.loaded_data || {}, //儲存已載入資料, 便於輪播(目前僅用於image layer)
                render_hint: options.render_hint || {}, //其他自訂參數
                // for leaflet start
                pane: options.pane || options.name, //放在哪一個pane上
                data: options.data || {}, //圖層資料
                style: options.style || {}, //圖層樣式
                onEachFeature: options.onEachFeature || function() {}, //圖層方法
                pointToLayer: options.pointToLayer || function() {}, //圖層方法
                // for leaflet end
                onLayerDidMount: options.onLayerDidMount || function() {}, //canvas圖層方法
                onDrawLayer: options.onDrawLayer || function() {}, //canvas圖層方法
                callback: options.callback || function() {},
                update: options.update || null, //目前僅適用於 render_hint.canvas_pane
                destroy: options.destroy || function() {}, //delete pane的callback

                // qplus 新增
                pane_tag_config: options.pane_tag_config || {},
                pane_order: isNaN(parseInt(options.pane_order)) ? 1000 : options.pane_order,
                sub_type: options.sub_type,
                information: options.information,
            }

            // 建立一個新的layer
            const pane_name = _options.pane
            const layer_name = _options.name

            // 是否已有pane?
            if (!this.panes[pane_name]) {
                this.create_pane(pane_name, _options)
            } else {
                this.panes[pane_name].addTo(this.map)

                const loaded_data = this.panes[pane_name].options.loaded_data
                const MAX_DATA_FILE_LENGTH = 72
                if (Object.keys(loaded_data).length > MAX_DATA_FILE_LENGTH) {
                    this.panes[pane_name].options.loaded_data = {}
                }

                if (_options.is_on_map) {
                    //若曾clear_pane, 需重新開啟 is_on_map
                    this.$set(this.panes_config[pane_name], 'is_on_map', true)
                }

                if (!this.panes_config[pane_name].is_user_set_opacity) {
                    this.panes_config[pane_name].opacity = _options.pane_opacity
                    this.change_opacity(pane_name, _options.pane_opacity)
                }

                this.panes_config[pane_name].text = _options.text
                this.panes_config[pane_name].type = _options.type
            }

            this.panes_config[pane_name].is_loading = true
            this.$emit('transfer-panes-config', this.panes_config)

            // 若已有舊layer => 清空該layer
            this.clear_layer(pane_name, layer_name)

            // 建立新layer
            if (_options.type === 'geojson') {
                this.create_geojson_layer(_options)
            } else if (_options.type === 'gis') {
                this.create_gis_layer(_options)
            } else if (_options.type === 'nineblock') {
                this.create_nineblock_layer(_options)
            } else if (_options.type === 'image') {
                this.create_image_layer(_options)
            } else if (_options.type === 'render') {
                this.create_render_layer(_options)
            } else if (_options.type === 'cluster') {
                this.create_cluster_layer(_options)
            } else {
                this.create_empty_layer(_options)
            }
        },
        create_pane: function(pane_name, options) {
            delete this.map._paneRenderers[pane_name]

            this.map.createPane(pane_name)
            this.panes[pane_name] = new L.LayerGroup([], options).addTo(this.map)
            this.panes[pane_name].$el = this.map.getPane(pane_name)

            // 紀錄 pane 設定
            this.$set(this.panes_config, pane_name, {
                name: pane_name,
                is_on_map: options.is_on_map,
                is_loading: true,
                text: options.text,
                pane_type: options.pane_type,
                opacity: Number(options.pane_opacity),
                opacity_tool: options.opacity_tool,
                order_tool: options.order_tool,
                pane_tag_tool: options.pane_tag_tool,
                layers: {},

                // qplus 新增
                is_user_set_opacity: false,
                data: options.data ? options.data : [],
                pane_tag_config: options.pane_tag_config,
                pane_order: options.pane_order,
                type: options.type,
                sub_type: options.sub_type,
                information: options.information,
            })

            // 圖層排序工具 置於該區最上層
            this.pane_order_type[options.pane_type].unshift(pane_name)
            this.pane_order_type[options.pane_type] = this.pane_order_type[options.pane_type].sort(
                (prev_pane_name, next_pane_name) => {
                    return this.panes_config[next_pane_name].pane_order - this.panes_config[prev_pane_name].pane_order
                }
            )

            // 更動 pane 透明度
            this.change_opacity(pane_name, options.pane_opacity)
        },
        async create_geojson_layer(options) {
            const pane_name = options.pane
            const pane = this.panes[pane_name]
            const loaded_data = pane.options.loaded_data

            const assign_empty_data_config = (status) => {
                if (options.pane_tag_config?.data_empty) {
                    this.$set(this.panes_config[pane_name].pane_tag_config, 'data_empty', {
                        ...this.panes_config[pane_name].pane_tag_config.data_empty,
                        status,
                    })
                }
            }

            const options_url = options.url
            if (loaded_data?.[options_url]?.layer) {
                const { layer, canvas_Layer, data_empty_status } = loaded_data[options.url]
                layer.addTo(pane)
                canvas_Layer && canvas_Layer.addTo(pane)
                const layer_id = layer._leaflet_id

                assign_empty_data_config(data_empty_status ?? false)

                this.after_create_layer(layer_id, options, pane)
                return
            }

            let data
            if (loaded_data?.[options_url]?.geojson) {
                data = loaded_data?.[options_url]?.geojson
            } else {
                const res = await get_remote_file_ajax(options.url)
                data = res.data
            }

            if (options.render_hint && options.render_hint.canvas_pane) {
                options.renderer = L.canvas({ pane: pane_name })
            }

            assign_empty_data_config(data?.features?.length === 0)

            const layer = L.geoJson(data, options)
            layer.addTo(pane)
            const layer_id = layer._leaflet_id

            if (options.renderer && options.update) {
                options.renderer.on('update', (event) => {
                    options.update(event, layer, pane)
                })
            }

            let canvas_Layer
            if (options.render_hint.draw_canvas) {
                let draw_canvas = function() {
                    this._data = null
                    this.onLayerDidMount = function() {
                        $(this._canvas).appendTo(pane.$el)
                        this.reset()

                        const mount_options = options.onLayerDidMount()
                        this._data = mount_options ? mount_options.data : []
                    }
                    this.reset = function() {
                        const topLeft = this._map.containerPointToLayerPoint([0, 0])
                        L.DomUtil.setPosition(this._canvas, topLeft)
                    }
                    this.onLayerWillUnmount = function() {
                        // -- custom cleanup before destroy, move canvas to default pane
                        $(this._canvas).appendTo(this._map._panes.overlayPane)
                    }
                    this.setData = function(data) {
                        // -- custom data set
                        this.needRedraw() // -- call to drawLayer
                    }
                    this.onDrawLayer = function(viewInfo) {
                        options.onDrawLayer(viewInfo, this._data)
                    }
                }
                draw_canvas.prototype = new L.CanvasLayer() // -- setup prototype

                canvas_Layer = new draw_canvas()
                canvas_Layer.addTo(pane) //call onLayerDidMount => reset => onDrawLayer
            }

            const is_save_layer_data = options?.render_hint?.save_layer_data
            if (!(is_save_layer_data === false)) {
                loaded_data[options.url] = {
                    layer,
                    canvas_Layer,
                    data_empty_status: this.panes_config[pane_name]?.pane_tag_config?.data_empty?.status,
                }
            } else {
                loaded_data[options.url] = { geojson: data }
            }

            this.after_create_layer(layer_id, options, pane)
        },
        create_gis_layer: function(options) {
            const pane_name = options.pane
            const pane = this.panes[pane_name]

            const add_gis_layer = (data) => {
                this.initial_wmarker_builder(options, () => {
                    this.after_create_layer(layer_id, options, pane)
                })

                const judge_whether_wmarker_display = options.render_hint.judge_whether_wmarker_display
                const pointToLayerCallback = options.pointToLayer
                options.pointToLayer = (feature, latlng) => {
                    if (judge_whether_wmarker_display) {
                        const is_wmarker_display = judge_whether_wmarker_display(feature)
                        if (!is_wmarker_display) return pointToLayerCallback(feature, latlng)
                    }

                    this.wmarkers[pane_name].list.push({
                        latlng: latlng,
                        feature: feature,
                    })

                    return pointToLayerCallback(feature, latlng)
                }

                const layer = L.geoJson(data, options).addTo(pane)
                const layer_id = layer._leaflet_id

                this.after_create_layer(layer_id, options, pane)
            }

            const loaded_data = pane.options.loaded_data

            if (loaded_data?.[options.url]) {
                add_gis_layer(loaded_data[options.url].data) // 由於 wmarker 所以要從 L.geoJson 重新 init
                return
            }

            $.getJSON(options.url, (data) => {
                add_gis_layer(data)
                loaded_data[options.url] = { data }
            })
        },
        initial_wmarker_builder: function(options, callback) {
            const pane_name = options.pane
            const pane = this.panes[pane_name]
            const render_hint = options.render_hint
            const wm_type = render_hint.sub_type
            const wm_config = this.config.wmarker[wm_type]
            const wm_max = wm_config.max || 500

            pane.wmarker_builder = new X.WindMarker()
            pane.wmarker_builder.setMarkerMax(wm_max)

            this.$set(this.wmarkers, pane_name, {
                key: +new Date(),
                wmarker_map: render_hint.wmarker_map,
                val_format: render_hint.val_format || null,
                scale: wm_config.scale || null,
                color: wm_config.color || null,
                show_wm_dir: wm_config.show_wm_dir === false ? false : true,
                zoom_ctrl: wm_config.zoom_ctrl || null,
                popup: wm_config.popup || null,
                list: [],
                callback: function() {
                    callback()
                },
                // qplus 將資料傳出 而非直接 popup
                emit_popup_callback: render_hint.emit_popup_callback || false,
            })
        },
        create_nineblock_layer: function(options) {
            this.nineblock_items_key += 1
            const pane_name = options.pane
            const pane = this.panes[pane_name]

            const render_hint = options.render_hint
            const nb_config = this.config.wmarker[render_hint.sub_type] //對照 wmarker_config設定檔

            this.$set(this.nineblock_items, pane_name, {
                url: options.url,
                config: nb_config, //(*)設定檔
                default_color: render_hint.default_color, //(*)欄位對照
                column_map: render_hint.column_map, //(*)欄位對照
                val_format: render_hint.val_format || null,
                callback: (layer_id) => {
                    this.after_create_layer(layer_id, options, pane)
                },
                // qplus 將資料傳出 而非直接 popup
                emit_popup_callback: render_hint.emit_popup_callback || false,
                pointToLayerCallback: render_hint.pointToLayerCallback || false,
            })
        },
        create_image_layer: function(options) {
            const pane_name = options.pane
            const pane = this.panes[pane_name]
            const bounds = options.render_hint.bounds
            const loaded_data = pane.options.loaded_data

            //loaded img圖層儲存於loaded_data, 避免輪播閃爍
            if (loaded_data && loaded_data[options.url]) {
                const layer = loaded_data[options.url]
                layer.addTo(pane)
                const layer_id = layer._leaflet_id

                this.after_create_layer(layer_id, options, pane)
                return
            }

            let img = new Image()
            let loaded_img
            img.src = options.url
            img.onload = () => {
                if (options.render_hint && options.render_hint.proj === 'EPSG:4326') {
                    loaded_img = ProjWizard.imageTrans(
                        img,
                        {
                            leftLng: bounds[0][1],
                            topLat: bounds[1][0],
                            rightLng: bounds[1][1],
                            bottomLat: bounds[0][0],
                        },
                        ProjWizard.projList.EPSG4326,
                        ProjWizard.projList.EPSG3857,
                        1,
                        1
                    )
                } else {
                    loaded_img = img
                }

                const layer = L.imageOverlay(loaded_img, bounds, options)
                layer.addTo(pane)
                const layer_id = layer._leaflet_id

                loaded_data[options.url] = layer

                this.after_create_layer(layer_id, options, pane)
            }
        },
        create_render_layer: function(options) {
            // render layer name 會等同 pane name
            const pane_name = options.pane
            const pane = this.panes[pane_name]
            const version = options.render_hint.kxd_version

            if (version === 2) {
                this.$set(this.kxd_renders_v2, pane_name, {
                    key: `${pane_name}${+new Date()}`, // for forecast text
                    text: options.text,
                    type: options.render_hint.sub_type,
                    mode: options.render_hint.mode,
                    smooth: options.render_hint.smooth,
                    contour: options.render_hint.contour || {},
                    colorbar: options.render_hint.colorbar || {},
                    header: options.data.header,
                    list: options.data.list,
                    render_max: options.render_hint.render_max,
                    data_type: options.render_hint.data_type,
                    color_text: options.render_hint.color_text,
                    layer: options.render_hint.layer,
                    title: options.render_hint.title,
                    callback: (layer_id) => {
                        this.after_create_layer(layer_id, options, pane)
                    },
                })
            } else {
                this.$set(this.kxd_renders, pane_name, {
                    key: `${pane_name}${+new Date()}`, // for forecast text
                    text: options.text,
                    type: options.render_hint.sub_type,
                    colorbar: options.render_hint.colorbar || {},
                    multi_drawer: options.render_hint.multi_drawer || null,
                    color_csv: options.render_hint.color_csv || null,
                    header: options.data.header,
                    list: options.data.list,
                    render_max: options.render_hint.render_max,
                    data_type: options.render_hint.data_type,
                    callback: (layer_id) => {
                        if (!pane.render) this.remove_pane(pane_name)

                        this.after_create_layer(layer_id, options, pane)
                    },
                })
            }
        },
        create_colorbar: function(options) {
            this.$set(this.colorbars, options.name, options)
        },
        get_colorbar: function(name) {
            return this.$refs['colorbar-' + name] ? this.$refs['colorbar-' + name][0] : null
        },
        delete_colorbar: function(name) {
            delete this.colorbars[name]
        },
        create_cluster_layer: function(options) {
            const pane_name = options.pane
            const pane = this.panes[pane_name]
            const show_zoom = options.render_hint.cluster_zoom || 10

            $.getJSON(options.url, (data) => {
                // marker
                let marker_list = options.data.markers ? options.data.markers.map((o) => o) : []
                const ml = marker_list.map((o) => {
                    o.marker.options.pane = pane_name
                    return o.marker
                })
                const marker_layer = L.layerGroup(ml).addTo(pane)

                // bind event when map room
                const renderer = L.canvas({ pane: pane_name })
                renderer.on('update', (event) => {
                    if (this.zoom >= show_zoom) {
                        pane.addLayer(marker_layer)
                    } else {
                        pane.removeLayer(marker_layer)
                    }
                })

                let area_map = {}
                let count_markers = []
                const layer = L.geoJson(data, {
                    renderer: renderer,
                    onEachFeature: (feature, layer) => {
                        const area_key = feature.properties[options.render_hint.cluster_area_key]
                        const poly = layer.feature.geometry
                        const original_style = {
                            color: 'transparent',
                        }
                        const highlight_style = {
                            color: '#ff3838',
                            fillOpacity: 0.3,
                        }

                        // set default style
                        layer.setStyle(original_style)

                        // build area and markers map
                        area_map[area_key] = {
                            markers: [],
                        }

                        // classify marker to area
                        const is_classified = []
                        marker_list.forEach((o, i) => {
                            const pt = turf.point([o.marker._latlng.lng, o.marker._latlng.lat])
                            const is_pt_in_poly = turf.booleanPointInPolygon(pt, poly)
                            if (is_pt_in_poly) {
                                area_map[area_key].markers.push(o)
                                is_classified.push(i)
                            }
                        })
                        // rm classified marker from list
                        marker_list = marker_list.filter((o, i) => {
                            return !is_classified.includes(i)
                        })

                        const center_latlng = layer.getBounds().getCenter()
                        const count = area_map[area_key].markers.length
                        if (count) {
                            count_markers.push({
                                latlng: center_latlng,
                                text: count,
                            })

                            layer
                                .on('mouseover', (e) => {
                                    if (this.zoom >= show_zoom) {
                                        return
                                    }
                                    layer.setStyle(highlight_style)
                                })
                                .on('mouseout', () => {
                                    layer.setStyle(original_style)
                                })
                                .on('click', () => {
                                    this.map.setView(center_latlng, show_zoom)
                                })
                        }
                    },
                }).addTo(pane)

                let draw_canvas = function() {
                    this._data = null
                    this.onLayerDidMount = function() {
                        $(this._canvas).appendTo(pane.$el)
                        this.reset()

                        this._data = count_markers
                    }
                    this.reset = function() {
                        const topLeft = this._map.containerPointToLayerPoint([0, 0])
                        L.DomUtil.setPosition(this._canvas, topLeft)
                        this._canvas.style.pointerEvents = 'none'
                    }
                    this.onLayerWillUnmount = function() {
                        // -- custom cleanup before destroy, move canvas to default pane
                        $(this._canvas).appendTo(this._map._panes.overlayPane)
                    }
                    this.setData = function(data) {
                        // -- custom data set
                        this.needRedraw() // -- call to drawLayer
                    }
                    this.onDrawLayer = function(info) {
                        const ctx = info.canvas.getContext('2d')
                        const data = this._data
                        ctx.clearRect(0, 0, info.canvas.width, info.canvas.height)

                        if (info.zoom >= show_zoom) {
                            return
                        }

                        const size = 16
                        const marker_color = options.render_hint.cluster_marker_color || 'orange'
                        for (let i = 0; i < data.length; i++) {
                            const d = [data[i].latlng.lat, data[i].latlng.lng]
                            if (info.bounds.contains([d[0], d[1]])) {
                                const dot = info.layer._map.latLngToContainerPoint([d[0], d[1]])

                                if (data[i].color) {
                                    ctx.strokeStyle = data[i].color
                                }

                                ctx.beginPath()
                                // 底色
                                ctx.fillStyle = marker_color
                                ctx.arc(dot.x, dot.y - 2, size / 2 + 5, 0, 360)
                                ctx.fill()
                                // 外框
                                ctx.strokeStyle = '#fff'
                                ctx.arc(dot.x, dot.y - 2, size / 2 + 5, 0, 360)
                                ctx.stroke()
                                // 數字
                                ctx.font = size + 'px Arial'
                                ctx.fillStyle = '#333'
                                ctx.textAlign = 'center'
                                ctx.textBaseline = 'middle'
                                ctx.fillText(data[i].text, dot.x, dot.y, size)
                                ctx.closePath()
                            }
                        }
                    }
                }
                draw_canvas.prototype = new L.CanvasLayer() // -- setup prototype

                const canvas_Layer = new draw_canvas()
                canvas_Layer.addTo(pane) //call onLayerDidMount => reset => onDrawLayer

                const layer_id = layer._leaflet_id
                this.after_create_layer(layer_id, options, pane)
            })
        },
        create_empty_layer: function(options) {
            const pane_name = options.pane
            const pane = this.panes[pane_name]

            let layer_id = null
            if (options.render_hint.show_pane_tag) {
                //強制顯示pane tag
                const layer = L.polyline([], {
                    pane: pane_name,
                }).addTo(pane)
                layer_id = layer._leaflet_id
            }

            this.after_create_layer(layer_id, options, pane)
        },
        after_create_layer: function(layer_id, options, pane) {
            const pane_name = options.pane
            const layer_name = options.name

            if (layer_id) {
                //紀錄layer
                this.$set(this.panes_config[pane_name].layers, layer_name, layer_id)
            }

            this.$set(this.panes_config[pane_name], 'is_loading', false)

            if (!this.panes_config[pane_name].is_on_map) {
                this.remove_pane(pane_name)
            } else {
                // 切換成loaded、已顯示的狀態
                this.$set(this.panes_config[pane_name], 'is_on_map', true)
            }

            if (options.callback) {
                options.callback(options, pane)
            }
        },
        set_map_view: function(options) {
            this.map.setView(options.latlng, options.zoom)
        },
        add_pane: function(pane_name) {
            //顯示圖層
            const pane = this.panes[pane_name]

            if (!pane) {
                return
            }

            pane.addTo(this.map)

            if (pane.render) {
                pane.render.add_render_layer()
            }
            if (pane.nb_render) {
                pane.nb_render.set_boundary()
            }

            this.panes_config[pane_name].is_on_map = true
        },
        remove_pane: function(pane_name) {
            //移除圖層
            let pane = this.panes[pane_name]

            if (!pane) {
                return
            }

            if (pane.render) {
                pane.render.remove_render_layer()
            }

            pane.removeFrom(this.map)

            this.panes_config[pane_name].is_on_map = false
        },
        clear_layer: function(pane_name, layer_name) {
            const pane = this.panes[pane_name]

            if (!layer_name || pane_name === layer_name) {
                // 此layer為pane的主產品||不指定layer => 清空整個pane的layer
                pane.eachLayer((_layer) => {
                    _layer.removeFrom(this.map)
                })
                pane.clearLayers()

                this.$set(this.panes_config[pane_name], 'layers', {})
            } else {
                // 此layer為其他疊加產品 => 僅清除指定的layer
                const layer_id = this.panes_config[pane_name].layers[layer_name]
                const layer = pane.getLayer(layer_id)

                if (pane.hasLayer(layer_id)) {
                    layer.removeFrom(this.map)
                    pane.removeLayer(layer)

                    Vue.delete(this.panes_config[pane_name].layers, layer_name)
                }
            }
        },
        clear_pane: function(pane_name) {
            //只保留pane & config

            const pane = this.panes[pane_name]
            if (!pane) {
                return
            }

            this.clear_layer(pane_name)

            if (pane.render) {
                Vue.delete(this.kxd_renders, pane_name)
                Vue.delete(this.kxd_renders_v2, pane_name)
                Vue.delete(this.colorbars, pane_name)
                Vue.delete(pane, 'render')
            }
            if (pane.nb_render) {
                Vue.delete(this.nineblock_items, pane_name)
            }

            this.$set(this.panes_config[pane_name], 'is_on_map', false)
        },
        delete_pane: function(pane_name) {
            const pane = this.panes[pane_name]
            if (!pane) {
                return
            }

            this.clear_pane(pane_name)

            $.each(this.pane_order_type, (type, list) => {
                list.forEach((name) => {
                    if (name === pane_name) {
                        list.splice(list.indexOf(name), 1)
                    }
                })
            })

            pane.options.destroy(this.map)

            $(pane.$el).remove()
            Vue.delete(this.panes_config, pane_name)
            Vue.delete(this.panes, pane_name)
        },
        get_bounds_latlng: function(target) {
            if (target._pxBounds) {
                // target為path/circle
                const N_E = target.getBounds()._northEast
                const S_W = target.getBounds()._southWest
                const top_lat = N_E.lat
                const bottom_lat = S_W.lat
                const center_lat = (top_lat + bottom_lat) / 2
                const right_lng = N_E.lng
                const left_lng = S_W.lng
                const center_lng = (right_lng + left_lng) / 2

                return {
                    center: { lat: center_lat, lng: center_lng },
                    top: { lat: top_lat, lng: center_lng },
                    right: { lat: center_lat, lng: right_lng },
                    bottom: { lat: bottom_lat, lng: center_lng },
                    left: { lat: center_lat, lng: left_lng },
                }
            } else if (target._icon) {
                //target為marker
                const latlng = target.getLatLng()
                return {
                    center: latlng,
                    top: latlng,
                    right: latlng,
                    bottom: latlng,
                    left: latlng,
                }
            }

            return {
                center: target._latlng,
                top: target._latlng,
                right: target._latlng,
                bottom: target._latlng,
                left: target._latlng,
            }
        },
        add_marker_tag: function(target, options) {
            const pane_name = options.pane
            const pane = this.panes[pane_name]

            //標籤 marker
            const class_name = options.div_icon_options.className || ''
            const tag_icon = L.divIcon(options.div_icon_options)
            const tag_distance = options.distance || 15 //單位為公里
            const tag_position = options.position || 'right' //標籤位置
            const theta_map = { right: 0, top: 90, left: 180, bottom: 270 }
            const target_bounds = this.get_bounds_latlng(target)
            const target_latlng = [target_bounds[tag_position].lat, target_bounds[tag_position].lng]
            const tag_theta = options.theta || theta_map[tag_position]
            const tag_marker_latlng = this.get_target_latlng(target_latlng, tag_theta, tag_distance)

            //標籤導引線
            const polyline_latlng = [target_latlng, tag_marker_latlng]
            const polyline_bg = L.polyline(polyline_latlng, {
                pane: pane_name,
                className: class_name,
                color: 'rgba(0, 0, 0, 0.2)',
                weight: 1.5,
                zIndexOffset: 1,
                renderer: L.svg(),
            })

            const polyline = L.polyline(polyline_latlng, {
                pane: pane_name,
                className: class_name,
                color: '#fff',
                weight: 1,
                dashArray: 5,
                zIndexOffset: 2,
                renderer: L.svg(),
            })

            const tag_marker = L.marker(tag_marker_latlng, {
                pane: pane_name,
                icon: tag_icon,
                draggable: 'true',
                riseOnHover: true,
                zIndexOffset: 3,
            })

            tag_marker.on('drag', function(e) {
                //計算標籤位於 target 的何處
                const x = e.latlng.lng - target_bounds.center.lng
                const y = e.latlng.lat - target_bounds.center.lat
                const n = y > 0 ? 1 : -1

                const R = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2))
                const theta = ((Math.acos(x / R) * 180) / Math.PI) * n

                let dir = null
                if (-45 < theta && theta < 45) {
                    dir = 'right'
                } else if (45 < theta && theta < 135) {
                    dir = 'top'
                } else if (135 < theta || theta < -135) {
                    dir = 'left'
                } else if (-135 < theta && theta < -45) {
                    dir = 'bottom'
                }

                if (dir) {
                    polyline_bg.setLatLngs([target_bounds[dir], e.latlng])
                    polyline.setLatLngs([target_bounds[dir], e.latlng])
                }
            })

            return L.featureGroup([polyline_bg, polyline, tag_marker]).addTo(pane)
        },
        draw_arrow: function name(options) {
            // 透過起始點經緯度&方向&距離 繪製箭頭
            const pane_name = options.pane
            const pane = this.panes[pane_name]

            const theta = options.theta //極座標角度(*)
            const arrow_length = options.length //箭頭長度(*)
            const path_color = options.color || 'red' //箭頭顏色
            const path_weight = options.weight || 3 //箭頭線粗細
            const path_opacity = options.opacity || 1
            const arrow_theta = options.arrow_theta || 40 //箭頭夾角
            const arrow_angle_length = options.arrow_angle_length || arrow_length / 4 //箭頭夾角長度, 單位為公里
            const arrow_tag_padding = options.text_padding || 5 //單位為公里
            const class_name = options.class_name || '' //箭頭class

            //路徑箭軸起訖經緯度
            const start_latlng = options.latlng //箭頭起點經緯度(*)
            const end_latlng = this.get_target_latlng(start_latlng, theta, arrow_length)

            //路徑箭矢
            const center_theta = theta + 180 >= 360 ? theta - 180 : theta + 180
            const arrow_right = this.get_target_latlng(end_latlng, center_theta + arrow_theta, arrow_angle_length)
            const arrow_left = this.get_target_latlng(end_latlng, center_theta - arrow_theta, arrow_angle_length)

            //箭頭陰影
            const arrow_bg = L.polyline([start_latlng, end_latlng, arrow_right, end_latlng, arrow_left], {
                pane: options.pane,
                className: class_name,
                color: 'rgba(0, 0, 0, 0.2)',
                weight: path_weight + 2,
                opacity: path_opacity,
            })

            // 箭頭直線
            const arrow_st = L.polyline([start_latlng, end_latlng], {
                pane: options.pane,
                className: class_name,
                color: path_color,
                weight: path_weight,
                opacity: path_opacity,
            })

            // 箭頭夾角
            const arrow_an = L.polyline([arrow_right, end_latlng, arrow_left], {
                pane: options.pane,
                className: class_name,
                color: path_color,
                weight: path_weight,
                opacity: path_opacity,
            })

            // 箭頭群組
            const group = L.featureGroup([arrow_bg, arrow_st, arrow_an])

            //箭頭顯示訊息(text純文字|tag_icon_options自訂icon)
            let arrow_tag = null
            if (options.text) {
                arrow_tag = L.divIcon({
                    className: 'arrow-text ' + class_name,
                    html: options.text,
                })
            } else if (options.tag_icon_options) {
                arrow_tag = L.divIcon(options.tag_icon_options)
            }

            if (arrow_tag) {
                const text_latlng = this.get_target_latlng(start_latlng, theta, arrow_length + arrow_tag_padding)

                const marker = L.marker(text_latlng, {
                    icon: arrow_tag,
                    pane: pane_name,
                    opacity: path_opacity,
                })

                group.addLayer(marker)
            }

            return group.addTo(pane)
        },
        get_target_latlng: function name(latlng, theta, length) {
            // 透過起始點經緯度&方向&距離 取得 另一點經緯度
            const lat_length = 110.7 //台灣附近1緯度大約=110km;
            const lng_length = 101.95 //台灣附近1經度大約=101km;
            const radian = (theta * Math.PI) / 180 //轉成弧度

            // 距離的經緯度 ≒ 0.01 * length * (sin|cos)
            const target_lat = latlng[0] + (length / lat_length) * Math.sin(radian)
            const target_lng = latlng[1] + (length / lng_length) * Math.cos(radian)

            return [target_lat, target_lng]
        },
        get_theta_by_dir: function(dir) {
            // 將風向角(dir) 轉為 極座標
            // 風向角的0度為南邊, 90度為西邊, 順時針轉
            // 極座標的0度為東邊, 90度為北邊, 逆時針轉
            let x = -dir + 270
            return x < 0 ? x + 360 : x
        },
        get_intersect_area: function(latlngs_A, latlngs_B) {
            // MultiPolygon會出錯, 僅支援Polygon
            const polygon_A = turf.polygon(latlngs_A)
            const polygon_B = turf.polygon(latlngs_B)

            return turf.intersect(polygon_A, polygon_B)
        },
        create_measure_item: function(options) {
            this.measure_items[options.key] = {
                pane_name: options.pane_name,
                pane: this.panes[options.pane_name],
                type: options.type,
                show_area: options.show_area,
                show_distance: options.show_distance,
                show_center_btn: options.show_center_btn,
                latlngs: options.latlngs,
                dragged: options.dragged,
                destory: options.destory,
            }
        },
        get_measure_item: function(key) {
            return {
                latlngs: this.measure_items[key].latlngs,
                delete: () => {
                    Vue.delete(this.measure_items, key)
                },
            }
        },

        open_product_setting_dialog(status) {
            this.product_setting_tool.status = status
        },

        close_product_setting_dialog() {
            this.product_setting_tool.status = false
            this.$refs.product_setting_btn.is_open_product_setting_dialog = false
        },

        check_in_maptool_colorbars_list(id) {
            return this.maptool_colorbars_list.includes(id)
        },

        get_timestamp_ISO() {
            let current_timestamp_gmt = new Date(this.current_timestamp)
            current_timestamp_gmt.setHours(current_timestamp_gmt.getHours() + 8)
            return current_timestamp_gmt.toISOString()
        },

        change_favorites_hint_text(text) {
            this.$emit('change_favorites_hint_text', text)
        },

        log(data, err) {
            if (DEV && err) console.error(err)
            else if (DEV) console.warn(data)
        },
    },
    watch: {
        basemap_config_list_for_reload_language: {
            deep: true,
            handler(new_config, old_config) {
                const is_config_changed = JSON.stringify(new_config) === JSON.stringify(old_config)
                if (is_config_changed) return
                this.initial_basemap()
                this.boundary_config.default = [...this.boundary]
                const all_boundary = this.boundary_config.item.list.map(({ name }) => name)
                all_boundary.forEach((boundary) => {
                    !this.boundary.includes(boundary) && this.panes[boundary].removeFrom(this.map)
                })
            },
        },
        measure_tool_config: {
            deep: true,
            handler() {
                this.measure_tool.options = this.measure_tool_config
                this.measure_tool.status = false
                this.measure_tool.stop()
                this.measure_tool.reset()
            },
        },
        basemap: {
            handler(basemap, last_basemap) {
                if (last_basemap) {
                    this.map.removeLayer(this.basemap_layer[last_basemap])
                }
                this.basemap_layer[basemap].addTo(this.map)

                this.map.setZoom(this.zoom)
            },
        },
        pane_order_type: {
            deep: true,
            handler(params) {
                this.panes_order_list = this.pane_order_type_list
                    .map((type) => {
                        return params[type]
                    })
                    .flat()
            },
        },
        panes_order_list: function(list) {
            // 依序排 z-index
            let z_index = 400
            for (let i = list.length - 1; i >= 0; i--) {
                let pane_name = list[i]
                $(this.panes[pane_name].$el).css('z-index', z_index)

                z_index++
            }
        },

        // 用vuex儲存地圖縮放程度 (for 我的最愛功能)
        'map._zoom': {
            deep: true,
            handler(new_value) {
                this.set_zoom(new_value)
            },
        },
    },
}
</script>

<style>
/*zoom 5~12*/
.kxd-map .zoom-level {
    display: none;
}

.kxd-map .zoom-normal,
.kxd-map[zoom='5'] .zoom-5,
.kxd-map[zoom='6'] .zoom-6,
.kxd-map[zoom='6'] .zoom-5,
.kxd-map[zoom='7'] .zoom-7,
.kxd-map[zoom='7'] .zoom-6,
.kxd-map[zoom='7'] .zoom-5,
.kxd-map[zoom='8'] .zoom-8,
.kxd-map[zoom='8'] .zoom-7,
.kxd-map[zoom='8'] .zoom-6,
.kxd-map[zoom='8'] .zoom-5,
.kxd-map[zoom='9'] .zoom-9,
.kxd-map[zoom='9'] .zoom-8,
.kxd-map[zoom='9'] .zoom-7,
.kxd-map[zoom='9'] .zoom-6,
.kxd-map[zoom='9'] .zoom-5,
.kxd-map[zoom='10'] .zoom-10,
.kxd-map[zoom='10'] .zoom-9,
.kxd-map[zoom='10'] .zoom-8,
.kxd-map[zoom='10'] .zoom-7,
.kxd-map[zoom='10'] .zoom-6,
.kxd-map[zoom='10'] .zoom-5,
.kxd-map[zoom='11'] .zoom-11,
.kxd-map[zoom='11'] .zoom-10,
.kxd-map[zoom='11'] .zoom-9,
.kxd-map[zoom='11'] .zoom-8,
.kxd-map[zoom='11'] .zoom-7,
.kxd-map[zoom='11'] .zoom-6,
.kxd-map[zoom='11'] .zoom-5,
.kxd-map[zoom='12'] .zoom-12,
.kxd-map[zoom='12'] .zoom-11,
.kxd-map[zoom='12'] .zoom-10,
.kxd-map[zoom='12'] .zoom-9,
.kxd-map[zoom='12'] .zoom-8,
.kxd-map[zoom='12'] .zoom-7,
.kxd-map[zoom='12'] .zoom-6,
.kxd-map[zoom='12'] .zoom-5 {
    display: inherit;
}
</style>

<style scoped>
/* 地圖容器 */
.kxd-map-container {
    position: relative;
    width: 100%;
    height: 100%;
    font-size: 1em;
    font-family: '微軟正黑體';
}

/* 地圖實體 */
.kxd-map-container .kxd-map {
    height: 100%;
    /*地圖底色*/
    background-color: #333;
    background-color: var(--map-bg-color);
    z-index: 1;
}

/* 地圖物件容器 */
.kxd-map-container .map-ctrl {
    position: absolute;
    height: 100%;
    width: 100%;
}

/* 地圖左上容器 */
.kxd-map-container .map-left-top-ctrl {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    left: 0;
    top: 0;
}

/* 地圖右上容器 */
.kxd-map-container .map-right-top-ctrl {
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    right: 0;
    top: 0;
    margin: 0.6rem;
    z-index: 3000;
    pointer-events: none;
}

.kxd-map-container .map-top-right-ctrl {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    right: 0;
    top: 3rem;
    margin: 0.6rem;
}

/* 地圖右下容器 */
.kxd-map-container .map-right-bottom-ctrl {
    display: flex;
    flex-direction: row-reverse;
    align-items: flex-end;
    right: 0;
    bottom: 0;
}

.kxd-map-container .map-left-bottom-ctrl {
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    left: 0;
    bottom: 0;
    width: 100%;
}

/* 截圖用的版權圖片 */
.kxd-map-container .capture-img__container {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: 28rem;
    margin: 0 4rem 4rem 0;
}

.kxd-map-container .capture-img {
    margin: 0 auto;
}

.kxd-map-container .capture-img__description {
    text-align: left;
    color: white;
}

/* 地圖容器內元件需使用.map-top-item */
/* 絕對上層, 選單使用 */

.kxd-map-container .map-root-item {
    z-index: 4000;
    position: absolute;
    right: 3rem;
}

.kxd-map-container .map-ctrl .map-top-item {
    z-index: 3000;
}
/* 相對上層, 附件使用 */
.kxd-map-container .map-ctrl .map-high-item {
    z-index: 2000;
}

/* 經緯度工具 <cursor-latlng> 容器*/
.leaflet-bottom.leaflet-left {
    display: none;
}

#cursor_latlng_container {
    position: absolute;
    bottom: 5px;
    left: 5px;
    z-index: 2;
}

/* 地圖工具 <map-btn-tool> 容器*/
#map_btn_tool_container {
    margin: 0.6em;
    touch-action: none;
    z-index: 4002;
}

#measure_tool_container {
    margin: 0.6em;
}

/* 箭頭顯示文字 */

.leaflet-marker-icon.arrow-text {
    color: #fff;
    text-shadow: 0 0 0.1em #000;
    font-size: 1em;
    line-height: 1em;
}

/*scroll*/
::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}
/*scroll背景*/
::-webkit-scrollbar-track {
    background-color: #f0f0f0;
}
/*scroll條*/
::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background-color: #bbb;
}
/* product: geojson-max_rain */

.colorbar-container {
    z-index: 2;
}
</style>

<style lang="scss" scoped>
.max-rain-colorbar__container {
    position: relative;
    z-index: 2;
    bottom: 7.5em;
    margin: 0 0 5px 2px;
}
</style>
